export var setAttribute = function (attr, value, el) {
    return el.setAttribute(attr, value);
};
